import { ChatType } from '@tribeplatform/gql-client/types'
import { useChat } from '@tribeplatform/react-sdk/hooks'

import { ChatDetails } from './ChatDetails.js'
import { GroupChatDetails } from './GroupChatDetails.js'

type Props = {
  chatId: string
}

export const DetailsSidebar = ({ chatId }: Props) => {
  const { data: chat } = useChat({
    variables: { id: chatId },
    useQueryOptions: {
      enabled: !!chatId,
    },
  })

  if (!chat) {
    return null
  }

  if (chat.type === ChatType.Group) {
    return <GroupChatDetails chat={chat} />
  }

  return <ChatDetails chat={chat} />
}
